const SCRIPT_ID = 'facebook-embed-script';

const options: any = {
  domain: 'connect.facebook.net',
  version: 'v3.2',
  cookie: false,
  status: false,
  xfbml: false,
  language: 'en_US',
  frictionlessRequests: false,
  debug: false,
};

let loadingPromise: Promise<any> | null = null;

export const initFacebook = () => {
  if (!loadingPromise) {
    loadingPromise = new Promise((resolve) => {
      const win: any = window;

      win.fbAsyncInit = () => {
        win.FB.init({
          version: options.version,
          cookie: options.cookie,
          status: options.status,
          xfbml: options.xfbml,
          frictionlessRequests: options.frictionlessRequests,
        });
        resolve(win.FB);
      };

      if (document.getElementById(SCRIPT_ID)) {
        return;
      }
      const js = document.createElement('script');
      js.id = SCRIPT_ID;
      js.async = true;
      js.defer = true;
      js.src = `//${options.domain}/${options.language}/sdk${options.debug ? '/debug' : ''}.js`;

      const body: HTMLElement | null = document.body;
      if (body) {
        body.appendChild(js);
      }
    });
  }
  return loadingPromise;
};
